module.exports = __webpack_public_path__ + "img/contributions1On.52e9f062.svg";